/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, shape, string, bool,
} from 'prop-types';

const styles = (theme) => ({
    container: {
        display: 'flex',
        marginTop: 25,
        [theme.breakpoints.down('xs')]: { width: '100%' },
    },

    horizontalContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '30%',
        [theme.breakpoints.down('xs')]: { marginLeft: 0 },

    },
    cardFlipSide: {
        marginTop: '-15px',
        width: '300px',
        height: '570px',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        transform: 'skewY(6deg)',
        boxShadow: `0px 4px 4px ${theme.palette.cgc?.cardFlipSideShadow || 'rgba(0, 0, 0, 0.25)'}`,
        background: theme.palette.cgc?.bgCardFlip || 'linear-gradient(271.54deg, #C4C4C4, #B6B6B6 0.59%, #F0F0F0 97.6%);',
        [theme.breakpoints.down(1660)]: {
            width: '240px',
            maxHeight: 380,
            minHeight: 380,
            marginTop: '-10px',
            transform: 'skewY(5deg)',
        },
        [theme.breakpoints.down('xs')]: {
            width: '20%',
            transform: 'skewY(3deg)',
            marginTop: -2,
            maxHeight: 350,
            minHeight: 350,
        },
    },
    cardFlipSideHorizontal: {
        marginLeft: '-15px',
        width: '380px',
        maxHeight: '256px',
        minHeight: '256px',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        transform: 'skewX(6deg)',
        background: theme.palette.cgc?.bgCardFlip || 'linear-gradient(91.54deg, #C4C4C4, #B6B6B6 0.59%, #F0F0F0 97.6%);',
        [theme.breakpoints.down(1660)]: {
            width: 350,
            maxHeight: '240px',
            minHeight: '240px',
            marginLeft: '-10px',
            transform: 'skewX(5deg)',
        },
        [theme.breakpoints.down('xs')]: {
            maxHeight: 40,
            minHeight: 40,
            marginRight: 0,
            transform: 'skewX(27deg)',
        },
    },
    editCardSideHorizontal: {
        width: '380px',
        maxHeight: '256px',
        minHeight: '256px',
        display: 'flex',
        boxSizing: 'border-box',
        border: `16px solid ${theme.palette.cgc?.bgCardFront || '#c4c4c4'}`,
        boxShadow: `0px 4px 4px ${theme.palette.cgc?.cardFlipShadow || 'rgba(0,0,0,0.25)'} `,
        [theme.breakpoints.down(1660)]: {
            width: 350,
            maxHeight: '280px',
            minHeight: '280px',
        },
    },
    editCardSide: {
        width: '384px',
        height: '576px',
        display: 'flex',
        boxSizing: 'border-box',
        border: `16px solid ${theme.palette.cgc?.bgCardFront || '#c4c4c4'}`,
        boxShadow: `0px 4px 4px ${theme.palette.cgc?.cardFlipSideShadow || 'rgba(0, 0, 0, 0.25)'}`,
        [theme.breakpoints.down(1660)]: {
            width: '280px',
            maxHeight: 380,
            minHeight: 380,
        },
        [theme.breakpoints.down('xs')]: {
            width: '80%',
            maxHeight: 350,
            minHeight: 350,
            marginRight: 35,
        },
    },
    textInsideCard: {
        minWidth: '100%',
        overflow: 'hidden',
        textAlign: 'justify',
        padding: 4,
        fontSize: 16,
        wordBreak: 'break-word',
        whiteSpace: 'break-spaces',
    },
});

const ReviewInsideCard = ({ classes, messageData, isHorizontal }) => (
    <div className={isHorizontal ? classes.horizontalContainer : classes.container}>
        <div className={isHorizontal ? classes.cardFlipSideHorizontal : classes.cardFlipSide} />
        <div className={isHorizontal ? classes.editCardSideHorizontal : classes.editCardSide}>
            <div
                cols="60"
                rows="8"
                className={classes.textInsideCard}
                style={messageData?.style}
            >
                {messageData?.text}
            </div>
        </div>
    </div>
);

ReviewInsideCard.propTypes = {
    classes: object.isRequired,
    messageData: shape({
        text: string,
        style: shape({
            textAlign: string,
            color: string,
        }),
    }),
    isHorizontal: bool.isRequired,
};

ReviewInsideCard.defaultProps = {
    messageData: {},
};

export default withStyles(styles)(ReviewInsideCard);
